import React, { Component } from 'react';
import { RUN_TIME_API_ENDPOINT, GetCurrentUserRoles, CommonHeaderOption } from "../common/common";
import { downloadCSV } from 'react-admin';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import Modal from 'react-responsive-modal';
import Swal from 'sweetalert2';

class PriceUpdateImport extends Component {
    state = {
        fileExtError: false,
        sizeError: false,
        selectedFile: null,
        showLoader: false,
        dataUpload: [],
    }

    componentWillMount() {
        const roleData = GetCurrentUserRoles();
        if (["$csa", "$ca"].indexOf(roleData[0]) === -1) {
            window.location.replace(window.location.origin + "/#/madagascar_products_list")
        }
    }

    handleImageChange = (e) => {
        e.preventDefault();
        const selectedFile = this.inputImgElement.files;
        const fileExtention = selectedFile && selectedFile[0].name.substring(selectedFile[0].name.lastIndexOf('.') + 1);
        console.log('fileExtention', fileExtention, selectedFile[0]);

        const maxSize = 10;

        if (((selectedFile[0].size / 1024 / 1024) > maxSize)) {
            this.setState({
                fileExtError: false,
                sizeError: true,
            });
        } else if ('csv' !== fileExtention) {
            this.setState({
                sizeError: false,
                fileExtError: true,
            });
        } else {
            this.setState({
                selectedFile: e.target.files[0],
                sizeError: false,
                fileExtError: false,
            });
        }
    }

    onSave = () => {
        this.setState({
            showLoader: true,
        });
        const formData = new FormData();

        // Update the formData object 
        formData.append('files', this.state.selectedFile);
        formData.append('file_name', this.state.selectedFile.name);

        const stateData = localStorage.getItem('__state');
        const userData = stateData ? JSON.parse(stateData) : false;
        const options = {}
        options.method = "POST";
        options.headers = {
            'Authorization': userData._token,
        }
        options.body = formData;

        const url = `${RUN_TIME_API_ENDPOINT}/madagascar_price_update_csv`;
        fetch(url, options)
            .then(res => {
                if (res.status === 401) {
                    // localStorage.removeItem("__state");
                    window.location.href = "#/login";
                }
                return res.json();
            })
            .then(json => {
                console.log('json==>', json);
                // const msg = '';
                const msg = json.data ? json.data[0].message : '';
                Swal.fire({
                    html: msg,
                    icon: 'success',
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.setState({
                            showLoader: false,
                        });
                        window.location.href = '#/madagascar_products_list';
                    }
                })
            }).catch(error => {
                Swal.fire({
                    html: 'Something went wrong. Please try again.',
                    icon: 'error',
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.setState({
                            showLoader: false,
                        });
                    }
                })
            });

    }
    onModalClose = () => {
        this.setState({
            showModal: false,
        });
        window.location.replace(window.location.origin + "/#/madagascar_products_list")
    }

    callExport = (e) => {
        const options = CommonHeaderOption();
        const apiUrl = RUN_TIME_API_ENDPOINT;
        e.preventDefault();
        options.method = 'GET';
        fetch(`${apiUrl}/madagascar_products_list?filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B%22id%22%2C%22DESC%22%5D`, options)
            .then(res => {
                return res.json();
            }).then(jsonD => {
                const prodList = jsonD.data;
                const csv = convertToCSV({
                    "fields": ['name', 'client_category_code', 'material_number', 'material_description', 'price_after_tax', 'status'],
                    "data": prodList
                });
                downloadCSV(csv, 'product_price_list');
            }
            );
    }

    render() {
        const { state, props, permissions } = this;
        console.log('props inside price upload===>', props);
        return (
            <React.Fragment>
                <div className="target-upload-container">
                    <label>Upload File</label>
                    <input
                        type="file"
                        accept=".csv"
                        name="flies[]"
                        ref={(inputFileImg) => { this.inputImgElement = inputFileImg; }}
                        onChange={this.handleImageChange}
                    />
                    {
                        (state.fileExtError || state.sizeError) &&

                        <div className="valid-file-upload-error">
                            {
                                state.fileExtError &&
                                <p>File type must be .csv</p>
                            }
                            {
                                state.sizeError &&
                                <p>File size must be less than 10 MB</p>
                            }
                        </div>
                    }
                    <div className="valid-file-upload">
                        <p>Instructions :</p>
                        <ul>
                            <li>Only CSV files are allowed.</li>
                            <li>File size should be less than 2 MB.</li>
                            <li>Please wait for the file upload to complete and for the confirmation message to appear before moving away from this page.</li>
                            <li>You will receive the results of the upload via email indicating how many records were added, updated and failed (if any).</li>
                        </ul>
                    </div>
                    <div className="upload-file-format-download">
                        <p>To export the current data, <a href="javascript:void(0);" onClick={this.callExport} >Click here</a> . You can then modify the exported data and select the file above and click Save below to update the prices.</p>
                    </div>
                    {
                        this.state.showLoader &&
                        <div className="login-loader" />
                    }
                    {
                        !this.state.showLoader &&
                        <div className="so-save-button">
                            <button onClick={this.onSave} disabled={!state.selectedFile}>Save</button>
                        </div>
                    }
                    {
                        state.showModal &&
                        <Modal open={state.showModal} onClose={this.onModalClose} center>
                            <h3>{state.message}</h3>
                        </Modal>
                    }
                </div>
            </React.Fragment>
        )
    }
}

export default PriceUpdateImport;